/**
 * サイドバーブランドロゴのフォールバック用アイコン (currentColor 塗りの inline SVG)。
 *
 * AdminLayout.tsx の BrandLogo (/admin 専用、固定テキスト "Image Gen" 込み) と
 * 同系の図形を、テキストを含まないアイコンのみとして切り出したもの。OEM パート
 * ナー向け画面 (/org-admin) では表示名がパートナーごとに変わるため、アイコン部分
 * だけを共通化し、呼び出し側でブランド名テキストを添える構成にしている。
 * AdminLayout.tsx はフェーズ1成果物のため変更せず、こちらは新規の共有コンポーネント
 * として追加した (図形は意図的に重複させている)。
 */
export function BrandGlyph({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      role="img"
      aria-hidden="true"
      className={className}
    >
      <rect x="1.25" y="1.25" width="25.5" height="25.5" rx="8" fill="none" stroke="currentColor" strokeWidth="2.5" />
      <circle cx="11" cy="10.5" r="2.25" fill="currentColor" />
      <path
        d="M6.5 20.5 L12 14.5 L15.5 18 L18 15.5 L21.5 20.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
